import rawRequest from '../utils/raw-request';
import transformers from './transformers';

const request = host => options => {
  return Promise.resolve(transformers[host](options))
    .then(opts => {
      return rawRequest(opts);
    }).then(r => {
      return r.body;
    });
};

export default request;



// WEBPACK FOOTER //
// ./src/request/simple.js